import {Injectable} from '@angular/core';
import {NavFactory} from './nav.factory';
import {NavItemCodes} from '../../enums/nav-item-codes.enum';
import {IconCode} from '../../enums/icon-code.enum';
import {PermissionArea} from '../../enums/permission-area.enum';

@Injectable()
export class NavRepositoryPoliciesFactory extends NavFactory {
    protected static basePath = '/repository-policies';
    protected static items = [
        {
            code: NavItemCodes.REPOSITORY,
            icon: IconCode.REPOSITORY_POLICIES,
            label: 'NAV.REPOSITORY_POLICIES.LABEL',
            description: 'NAV.REPOSITORY_POLICIES.DESC',
            path: NavRepositoryPoliciesFactory.basePath,
            permissionArea: PermissionArea.REPOSITORY_POLICIES_REGISTRY,
            cy: 'repository-policies'
        },
        {
            code: NavItemCodes.REPOSITORY_LABEL_SHORT,
            icon: IconCode.REPOSITORY_POLICIES,
            label: 'NAV.REPOSITORY_POLICIES.LABEL_SHORT',
            path: NavRepositoryPoliciesFactory.basePath,
            permissionArea: PermissionArea.REPOSITORY_POLICIES_REGISTRY,
        },
        {
            code: NavItemCodes.REPOSITORY_LABEL_BROKEN,
            icon: IconCode.REPOSITORY_POLICIES,
            label: 'NAV.REPOSITORY_POLICIES.LABEL_BROKEN',
            description: 'NAV.REPOSITORY_POLICIES.DESC',
            path: NavRepositoryPoliciesFactory.basePath,
            permissionArea: PermissionArea.REPOSITORY_POLICIES_REGISTRY,
        },
        {
            code: NavItemCodes.REPOSITORY_POLICY,
            icon: IconCode.PREVIEW,
            label: 'NAV.REPOSITORY_POLICY.LABEL',
            path: ({policyId}) => [NavRepositoryPoliciesFactory.basePath, policyId],
        },
        {
            code: NavItemCodes.REPOSITORY_POLICY_BREADCRUMB,
            icon: IconCode.PREVIEW,
            label: 'NAV.REPOSITORY_POLICY.BREADCRUMB_LABEL',
            path: ({policyId}) => [NavRepositoryPoliciesFactory.basePath, policyId],
        },
    ];
}
